import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./styles.css";
import Overlay from "./components/Overlay";
import Signup from "./signup";
import Login from "./login";
import Logo from "../../assets/images/logo-with-text.png";
import withMiddleware from "../../middleware";
import loginHandler, { routeAfterLoginOrSignup } from "./login/handler";
import { logoutUser, receiveLogin } from "../../actions";
import { useHistory } from "react-router-dom";
import { updateUser } from "../../actions/app";
import { useUtils } from "../../utils";
import { firebaseApp } from "../../components/firebase";

const AuthPage = (props) => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { showToast } = useUtils();
  const [loading, setLoading] = useState(true);
  const [isSignUp, setIsSignUp] = useState(location.pathname === "/signup");
  const { auth } = useSelector((state) => ({
    auth: state.auth,
  }));
  const [userDetails, setUserDetails] = useState({
    email: "",
    firstName: "",
    lastName: "",
  });

  useEffect(() => {
    const unsubscribe = firebaseApp.auth().onAuthStateChanged(handleLogging);

    return () => {
      unsubscribe();
    };
  }, []);

  async function handleLogging(firebaseUser, userCredentials) {
    if (firebaseUser && !auth.isAuthenticated) {
      try {
        setLoading(true);
        // TODO: Removed!!
        // if (!redirectionResult) {
        //   redirectionResult = await firebaseApp.auth().getRedirectResult();
        // }
        // console.log(firebaseApp.auth().currentUser, "currentUser");
        // console.log(userCredentials, "userCredentials");
        // console.log(firebaseUser, "firebaseUser");
        dispatch(receiveLogin(firebaseUser));
        props.service.updateUser(firebaseUser);
        loginHandler(props.service)
          .then(({ user, route }) => {
            if (!user?.user_id && !isSignUp) {
              handleSignupCase(firebaseUser);
            } else {
              setLoading(false);
              dispatch(updateUser(user));
              routeAfterLoginOrSignup(history, route, user);
            }
          })
          .catch(async (error) => {
            if (error?.message === "Your account does not exists in our records" && !isSignUp) {
              handleSignupCase(firebaseUser);
            } else {
              setLoading(false);
              dispatch(logoutUser());
              debugger;
              showToast("error", error?.message);
              throw error;
            }
          });
      } catch (err) {
        setLoading(false);
        dispatch(logoutUser());
        showToast("error", err?.message);
      }
    } else {
      setLoading(false);
    }
  }

  const handleSignupCase = (firebaseUser) => {
    if (firebaseUser?.providerData?.[0]?.providerId == "password") return;
    // TODO: Don't do this for cases where user is sign up with email and password because it's already processed by the user
    setLoading(false);
    showToast("info", "Looks like you are new here please provide these details to create an account");
    setIsSignUp(true);
    props.service.updateUser(firebaseUser);
    setUserDetails({
      email: firebaseUser?.email,
      firstName: firebaseUser?.displayName?.split(" ")[0],
      lastName: firebaseUser?.displayName?.split(" ")[1],
      password: "random",
      isSocialSignupFlow: true,
    });
  };

  const handleFormSwitch = (page) => {
    setIsSignUp(page == "signup");
  };

  const isInvitationLink = useMemo(() => {
    return window.location.search?.includes("/process-invite");
  }, []);

  const isLifeTimeMembershipInviteLink = useMemo(() => {
    return window.location.search?.includes("/process-life-time-membership-invite");
  }, []);

  return (
    <div className="auth-container">
      <img src={Logo} className="app-logo" alt="OptimalHRV Logo" />
      {isInvitationLink ? (
        <div id="invitation-info">
          <span>Note: Please SignIn or SignUp To Join This Invitation</span>
        </div>
      ) : null}
      {isLifeTimeMembershipInviteLink ? (
        <div id="invitation-info">
          <span>Note: Please SignIn or SignUp To Claim The Lifetime Membership</span>
        </div>
      ) : null}
      <div
        className={`container ${isSignUp ? "right-panel-active" : ""}`}
        id="container"
        style={{
          pointerEvents: loading ? "none" : "auto",
        }}
      >
        <div className="auth-tabs">
          <button
            type="button"
            className={`auth-tab ${!isSignUp ? "active" : ""}`}
            onClick={() => setIsSignUp(false)}
            disabled={!isSignUp}
          >
            Sign In
          </button>
          <button
            type="button"
            className={`auth-tab ${isSignUp ? "active" : ""}`}
            onClick={() => setIsSignUp(true)}
            disabled={isSignUp}
          >
            Sign Up
          </button>
        </div>
        {loading ? (
          <div className="my-loader-wrapper">
            <span className="my-loader"></span>
          </div>
        ) : null}
        {isSignUp ? (
          <Signup loading={loading} setLoading={setLoading} handleLogging={handleLogging} userDetails={userDetails} />
        ) : (
          <Login loading={loading} setLoading={setLoading} />
        )}
        <Overlay onButtonClick={handleFormSwitch} />
      </div>
    </div>
  );
};

export default withMiddleware(AuthPage);
